import { Component } from '@theme/component';

class FlyToCart extends Component {
  source;
  useSourceSize = false;
  destination;

  connectedCallback() {
    super.connectedCallback();
    // Animation disabled - remove immediately
    this.remove();
  }
}

if (!customElements.get('fly-to-cart')) {
  customElements.define('fly-to-cart', FlyToCart);
}
